import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { IUrlProvider, URL_PROVIDER_SERVICE } from 'src/app/lib/setting/interfaces';

@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.css']
})
export class PdfComponent implements OnDestroy, OnInit {

  @Input() safeUrl: SafeResourceUrl;

  private _subscriptions: Subscription[] = [];

  constructor(
    @Optional() @Inject(URL_PROVIDER_SERVICE) public urlProvider: IUrlProvider
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    if(this.urlProvider) this._subscriptions.push(this.urlProvider.safeUrl$.subscribe((url: string) => this.safeUrl = url));
  }

}
